import React, { useState } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { MoreHorizontal, Edit, Trash2 } from 'lucide-react'
import PaginationComponent from '@/components/common/PaginationComponent' 
import { formatTableText } from '@/lib/tableUtils'

const VehiclesTable = ({ 
  vehicles, 
  onEditVehicle, 
  onDeleteVehicle,
  currentPage,
  totalPages,
  totalVehicles,
  pageSize,
  onPageChange,
  userRole
}) => {
 
  
  const getStatusVariant = (status) => {
    switch (status) {
      case 'Active':
        return 'active'
      case 'Inactive':
        return 'delayed'
      default:
        return 'default'
    }
  }

  
  const showTransporterColumn = userRole !== 'port_admin';

  return (
    <div className="rounded-md border overflow-hidden w-full">
      <div className="max-h-[calc(100vh-250px)] overflow-auto w-full">
        <Table>
          <TableHeader className=" sticky top-0 z-10">
            <TableRow>
              <TableHead className="h-10 px-4 py-1 min-w-[200px]">Vehicle Number</TableHead>
              <TableHead className="h-10 px-4 py-1 min-w-[150px]">Vehicle Type</TableHead>
              <TableHead className="h-10 px-4 py-1 min-w-[150px]">Capacity</TableHead>
              {showTransporterColumn && (
                <TableHead className="h-10 px-4 py-1 min-w-[200px]">Transporter</TableHead>
              )}
              <TableHead className="h-10 px-4 py-1 min-w-[100px]">Status</TableHead>
              <TableHead className="h-10 px-4 py-1 min-w-[200px]">Created At</TableHead>
              <TableHead className="h-10 px-4 py-1 text-right min-w-[80px]">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {vehicles.map((vehicle) => ( 
              <TableRow key={vehicle.id} className="hover:bg-transparent border-border">
                <TableCell className="h-10 px-4 py-1 uppercase">{formatTableText(vehicle.vehicleNumber) || 'N/A'}</TableCell>
                <TableCell className="h-10 px-4 py-1">{formatTableText(vehicle.vehicleType) || 'N/A'}</TableCell>
                <TableCell className="h-10 px-4 py-1">{formatTableText(vehicle.capacity) || 'N/A'}</TableCell>
                {showTransporterColumn && (
                  <TableCell className="h-10 px-4 py-1">{formatTableText(vehicle.transporterName) || 'N/A'}</TableCell>
                )}
                <TableCell className="h-10 px-4 py-1">
                  <Badge
                    variant={getStatusVariant(vehicle.status)}
                    className="inline-block text-center w-[80px]"
                  >
                    {vehicle.status || 'N/A'}
                  </Badge>
                </TableCell>
                <TableCell className="h-10 px-4 py-1">{formatTableText(vehicle.createdAt) || 'N/A'}</TableCell>
                <TableCell className="h-10 px-4 py-1 text-right">
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" className="h-8 w-8 p-0">
                        <MoreHorizontal className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                      <DropdownMenuItem onClick={() => onEditVehicle(vehicle.id)}>
                        <Edit className="mr-2 h-4 w-4" />
                        Edit Vehicle
                      </DropdownMenuItem>
                      <DropdownMenuItem onClick={() => onDeleteVehicle(vehicle.id)} className="text-red-500">
                        <Trash2 className="mr-2 h-4 w-4" />
                        Delete Vehicle
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      
      <PaginationComponent 
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalVehicles}
        pageSize={pageSize}
        onPageChange={onPageChange}
        className="border-t"
      />
    </div>
  )
}

export default VehiclesTable